export class Version {
    id: number;
    version_label: string;
    release_date: string;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/models/version.ts